var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.7551 63.8383C50.3836 63.8383 64.6743 49.5476 64.6743 31.9192C64.6743 14.2907 50.3836 0 32.7551 0C15.1266 0 0.835938 14.2907 0.835938 31.9192C0.835938 49.5476 15.1266 63.8383 32.7551 63.8383Z",
    fill: "#ED3125"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.2249 27.5635C35.7498 26.9724 36.1802 26.3766 36.7192 25.8706C38.3743 24.3101 40.332 23.5251 42.6207 23.544C43.8786 23.5535 45.1175 23.6433 46.3281 23.9933C49.0991 24.7924 50.7069 26.7028 51.4777 29.4077C52.0546 31.4363 52.1587 33.5217 52.1634 35.6118C52.1728 40.019 52.1492 44.431 52.1586 48.8382C52.1586 49.2496 52.0452 49.3584 51.6385 49.3584C49.3687 49.3394 47.0941 49.3394 44.8243 49.3584C44.4224 49.3631 44.3373 49.2401 44.3373 48.8618C44.3515 44.6674 44.3515 40.473 44.3373 36.2739C44.3325 35.2241 44.2663 34.1696 43.9732 33.1482C43.4294 31.2661 42.0816 30.3062 40.1098 30.4102C37.4144 30.5521 36.0146 31.8856 35.6742 34.6235C35.5938 35.2761 35.5512 35.9334 35.556 36.5907C35.5607 40.6716 35.5512 44.7525 35.5654 48.8335C35.5654 49.2401 35.4661 49.3584 35.05 49.3584C32.7613 49.3394 30.4725 49.3394 28.1838 49.3584C27.815 49.3631 27.7109 49.2638 27.7109 48.8902C27.7204 40.8135 27.7204 32.732 27.7109 24.6553C27.7109 24.2533 27.8433 24.1635 28.2216 24.1635C30.3921 24.1777 32.5674 24.1824 34.7379 24.1635C35.1398 24.1588 35.2391 24.2912 35.2344 24.6695C35.2108 25.6341 35.2249 26.5988 35.2249 27.5635Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.7747 36.7942C22.7747 40.79 22.77 44.7858 22.7842 48.7816C22.7842 49.2262 22.6754 49.3586 22.2167 49.3538C19.9469 49.3302 17.6771 49.3349 15.4026 49.3491C15.0384 49.3538 14.9297 49.2592 14.9297 48.8857C14.9391 40.7948 14.9391 32.7038 14.9297 24.6082C14.9297 24.2725 15.0101 24.1542 15.3647 24.1542C17.6676 24.1684 19.9706 24.1732 22.2735 24.1495C22.718 24.1448 22.7747 24.315 22.7747 24.698C22.77 28.7364 22.7747 32.7653 22.7747 36.7942Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.4027 16.1437C23.4074 18.6546 21.3693 20.6975 18.863 20.6975C16.3899 20.6975 14.3376 18.6546 14.3282 16.1815C14.3187 13.6847 16.371 11.6277 18.8725 11.6277C21.3598 11.6371 23.4027 13.6752 23.4027 16.1437Z",
    fill: "#FEFEFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/Linkdin.44b1210a9fffd48717c0e109f3d51ec5.svg";
export { ForwardRef as ReactComponent };